import script from "./community-settings.vue?vue&type=script&lang=ts&setup=true"
export * from "./community-settings.vue?vue&type=script&lang=ts&setup=true"

import "./community-settings.vue?vue&type=style&index=0&id=74d6d18c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d6d18c"]])

export default __exports__